export const chatWithUsConfig = {
  contactOptions: [
    {
      icon: 'https://i.ibb.co/3y0RJJyL/d03c60255527030851cda960b94597dd30be95c3.png', // Chatbot icon
      title: 'Start Chatting',
      bgColor: '#E0E0E0',
    },
    {
      icon: 'https://i.ibb.co/nsTy2DHs/frame-2.png',
      title: 'Phone',
      detail: '+1 (876) 922-9568',
      bgColor: '#E0E0E0',
    },
    {
      icon: 'https://i.ibb.co/gb8ZmHr5/frame-3.png',
      title: 'WhatsApp',
      detail: '+1 (876) 922-9568',
      bgColor: '#E0E0E0',
    },
    {
      icon: 'https://i.ibb.co/4nr27T9K/frame-4.png',
      title: 'Email',
      detail: 'info@workpermitdept.go.vjm',
      bgColor: '#E0E0E0',
    },
    {
      icon: 'https://i.ibb.co/S4nm1VsC/frame-1.png',
      title: 'Location',
      detail: '1F North Street, Kingston, Jamaica',
      bgColor: '#E0E0E0',
    },
  ],
};